const actions = {
  SET_STATE: 'plans/SET_STATE',
  FETCH_ALL_PLANS: 'plans/FETCH_ALL_PLANS',
}

export default actions
